define('modules/accounts/status/products/mdirector/model',['require','exports','module','app','env','base/model'],function(require, exports, module) {
    "use strict";

    var app = require("app");
    var Config = require("env");

    var BaseModel = require("base/model");

    var Model = BaseModel.extend({
        url: function() {
            return Config.backendUrl + "/accounts/status-mdirector/"+this.get('groupId');
        },
        initialize: function() {
            this.initRequestEvents();
        },
        getCompanyBalanceById: function(empId) {
            var companyBalance = _.filter(this.get("companiesBalance"), function(company) {
                return parseInt(company.empId) === parseInt(empId);
            }, empId);

            return companyBalance[0];
        },
        companyBalanceHasData: function(empId) {
            var companyBalance = this.getCompanyBalanceById(empId);
            return (companyBalance && companyBalance.hasOwnProperty("numEmails"));
        },
        getNumOfEmailsPerMonth: function(empId) {
            var companyBalance = this.getCompanyBalanceById(empId);

            var numOfEmailsPerMonth = 0;
            if (companyBalance && !_.isEmpty(companyBalance.numOfEmailsPerMonth)) {
                numOfEmailsPerMonth = parseInt(companyBalance.numOfEmailsPerMonth);
            }

            return numOfEmailsPerMonth;
        },
        getConsumedEmailsPerMonth: function(empId) {
            var companyBalance = this.getCompanyBalanceById(empId);

            var consumedEmailPerMonth = 0;
            if (companyBalance && parseInt(companyBalance.numOfEmailsPerMonth) && companyBalance.hasOwnProperty("numOfEmailsPerMonthLeft")) {
                consumedEmailPerMonth = companyBalance.numOfEmailsPerMonth - companyBalance.numOfEmailsPerMonthLeft;
            }

            return consumedEmailPerMonth;
        }
    });

    module.exports = Model;
});

